import React from 'react';

import { Typography } from '@mui/material';

import { AuthPaperBox } from 'src/components/auth';

export const MaintenancePage: React.FC = () => {
  return (
    <AuthPaperBox>
      <Typography variant="h5" mt={2.5} mb={1}>
        Maintenance in progress
      </Typography>
      <Typography sx={theme => ({ color: theme.palette.text.secondary })}>
        Sorry, we are down for scheduled maintenance right now. Check back soon.
      </Typography>
    </AuthPaperBox>
  );
};
